import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Continued"
}
const _hoisted_2 = {
  key: 1,
  class: "ToBeContinue"
}
const _hoisted_3 = {
  key: 2,
  class: "EndOfType"
}
const _hoisted_4 = {
  key: 3,
  class: "EndOfType"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["PDFOnlineTypeBlockWrap", {
      'IsFirst': _ctx.disableContinued,
      'IsLast': _ctx.disableToBeContinued,
    }])
  }, [
    (!_ctx.disableContinued)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.mixWB('CONTINUATION_OF_X', [_ctx.titles.type])), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (!_ctx.disableToBeContinued)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.mixWB('CONTINUED_ON_NEXT_PAGE')), 1))
      : (_ctx.isDamageRelatedScreeningProject)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.mixWB('BACK_TO')) + ": ", 1),
            _createElementVNode("a", {
              href: '#' + _ctx.encodedTitles.section
            }, _toDisplayString(_ctx.mixWB('OVERVIEW_OF_BUILDING_PARTS')), 9, _hoisted_5),
            _hoisted_6,
            _createElementVNode("a", {
              href: '#' + _ctx.encodedTitles.category
            }, _toDisplayString(_ctx.mutatedCategoryTitle), 9, _hoisted_7)
          ]))
  ], 2))
}